// 按需加载 AntD Icon，可缩小JS体积 2MB（压缩前）
export { default as GlobalOutlined } from '@ant-design/icons/GlobalOutlined';
export { default as LogoutOutlined } from '@ant-design/icons/LogoutOutlined';
export { default as ExclamationCircleOutlined } from '@ant-design/icons/ExclamationCircleOutlined';
export { default as TableOutlined } from '@ant-design/icons/TableOutlined';
export { default as ReloadOutlined } from '@ant-design/icons/ReloadOutlined';
export { default as LoadingOutlined } from '@ant-design/icons/LoadingOutlined';
export { default as CloseCircleOutlined } from '@ant-design/icons/CloseCircleOutlined';
export { default as DownloadOutlined } from '@ant-design/icons/DownloadOutlined';
